"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ColorDrop = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6,13.81 C6,16.687 8.519,19.117 11.5,19.117 C14.481,19.117 17,16.686 17,13.81 C17,9.39 11.562,5.278 11.508,5.24 C11.438,5.278 6,9.388 6,13.81 Z M5,13.809 C5,8.9 10.849,4.47 10.908,4.425 L11.5,4 L12.092,4.425 C12.151,4.468 18,8.898 18,13.81 C18,17.23 15.023,20.117 11.5,20.117 C7.977,20.116 5,17.228 5,13.809 Z M12,16 C13.603888,15.9346596 14.9965099,14.6177146 15,13.0125 C15,11.4025 13.595,10.092 12,10.025 L12,16 Z M14,13.0125 C14,13.6975 13.53,14.302 13,14.659 L13,11.366 C13.53,11.724 14,12.3285 14,13.0125 Z" })));
};
ColorDrop.displayName = 'ColorDrop';
exports.default = ColorDrop;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ColorDrop.js.map